/**
 * @typedef  module:EventService.EventAttributes
 * @readonly
 * @description Attribute is a value that an event can have that is used for displaying
 *     event titles and icons. It is also used for filtering events.
 * @property {module:EventService.EventAttribute} pin sort:10
 * @property {module:EventService.EventAttribute} delivery sort:20
 * @property {module:EventService.EventAttribute} call sort:30
 * @property {module:EventService.EventAttribute} autoSecure sort:40
 * @property {module:EventService.EventAttribute} garageEnter sort:50
 * @property {module:EventService.EventAttribute} garageExit sort:60
 * @property {module:EventService.EventAttribute} garageOpen sort:70
 * @property {module:EventService.EventAttribute} garageClose sort:80
 * @property {module:EventService.EventAttribute} person sort:90
 * @property {module:EventService.EventAttribute} animal sort:100
 * @property {module:EventService.EventAttribute} package sort:110
 * @property {module:EventService.EventAttribute} vehicle sort:120
 * @property {module:EventService.EventAttribute} object sort:130
 * @property {module:EventService.EventAttribute} pet pet:140
 * @property {module:EventService.EventAttribute} car sort:150
 * @property {module:EventService.EventAttribute} baby sort:160
 * @property {module:EventService.EventAttribute} favorite sort:170
 * @property {module:EventService.EventAttribute} highlight sort:180
 * @property {module:EventService.EventAttribute} unknown sort:900
 * @property {module:EventService.EventAttribute} none sort:910
 */
const eventAttributes = Object.freeze({
    pin: {
        id: 'pin',
        sort: 10
    },
    delivery: {
        id: 'delivery',
        sort: 20
    },
    call: {
        id: 'call',
        sort: 30
    },
    autoSecure: {
        id: 'autoSecure',
        sort: 40
    },
    garageEnter: {
        id: 'garageEnter',
        sort: 50
    },
    garageExit: {
        id: 'garageExit',
        sort: 60
    },
    garageOpen: {
        id: 'garageOpen',
        sort: 70
    },
    garageClose: {
        id: 'garageClose',
        sort: 80
    },
    person: {
        id: 'person',
        sort: 90
    },
    animal: {
        id:'animal',
        sort: 100
    },
    package: {
        id: 'package',
        sort: 110
    },
    vehicle: {
        id: 'vehicle',
        sort: 120
    },
    object: {
        id: 'object',
        sort: 130
    },
    pet: {
        id: 'pet',
        sort: 140
    },
    car: {
        id: 'car',
        sort: 150
    },
    baby: {
        id: 'baby',
        sort: 160
    },
    favorite: {
        id: 'favorite',
        sort: 170
    },
    highlight: {
        id: 'highlight',
        sort: 180
    },
    unknown: {
        id: 'unknown',
        sort: 900
    },
    none: {
        id: 'none',
        sort: 910
    }
});
export default eventAttributes;
